import {
  getFromLocalStorage,
  saveToLocalStorage,
} from "src/utils/localStorage";
import { CREATOR_MESSAGE_DRAFTS_KEY } from "./constants";
import { MessageDraft, MessageDraftData } from "./types";

export const removeDraftFromLocalStorage = (
  wsWorkspaceUuid: string,
  wsProjectUuid: string,
) => {
  const savedDrafts = getFromLocalStorage<MessageDraft>(
    CREATOR_MESSAGE_DRAFTS_KEY,
  );
  if (!savedDrafts) return;
  delete savedDrafts?.[wsWorkspaceUuid]?.[wsProjectUuid];
  saveToLocalStorage(CREATOR_MESSAGE_DRAFTS_KEY, savedDrafts);
};

export const saveDraftInLocalStorage = (
  messageData: MessageDraftData,
  wsWorkspaceUuid: string,
  wsProjectUuid: string,
) => {
  const savedDrafts =
    getFromLocalStorage<MessageDraft>(CREATOR_MESSAGE_DRAFTS_KEY) ?? {};

  if (messageData.subject.length === 0 && messageData.message.length === 0) {
    removeDraftFromLocalStorage(wsWorkspaceUuid, wsProjectUuid);
    return;
  }

  const dataFoWorkspace = savedDrafts[wsWorkspaceUuid] ?? {};

  const updatedDrafts = {
    ...savedDrafts,
    [wsWorkspaceUuid]: {
      ...dataFoWorkspace,
      [wsProjectUuid]: messageData,
    },
  };

  saveToLocalStorage(CREATOR_MESSAGE_DRAFTS_KEY, updatedDrafts);
};
